var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',_vm._g({staticClass:"al-link",class:{
    'is-small': _vm.isSmall,
    'has-icon': _vm.hasIcon,
    'is-disabled': _vm.isDisabled
  },attrs:{"test-id":"al-link","href":_vm.href,"aria-disabled":_vm.isDisabled}},{ click: _vm.to !== null ? _vm.nuxtGoTo : _vm.emitClick }),[_c('span',{staticClass:"al-link_description"},[_vm._t("default")],2),(_vm.hasIcon)?_c('al-icon',{staticClass:"al-button_icon al-icon",attrs:{"name":_vm.hasIcon}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }